export default __webpack_public_path__ + "assets/home-one-two-small.0a0f91b84841a4efc2b6c7a447549353.png";